var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/login/header.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
env.getTemplate("macros/form-validation.j2", false, "core/templates/modal/user/login/header.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("hasErrors")) {
var t_6 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_6);
if(t_1.hasOwnProperty("validatedField")) {
var t_7 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_7);
output += "\n";
env.getTemplate("macros/urls.j2", false, "core/templates/modal/user/login/header.j2", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(t_8.hasOwnProperty("signUpUrl")) {
var t_11 = t_8.signUpUrl;
} else {
cb(new Error("cannot import 'signUpUrl'")); return;
}
context.setVariable("signUpUrl", t_11);
if(t_8.hasOwnProperty("loginUrl")) {
var t_12 = t_8.loginUrl;
} else {
cb(new Error("cannot import 'loginUrl'")); return;
}
context.setVariable("loginUrl", t_12);
if(t_8.hasOwnProperty("forgotPasswordUrl")) {
var t_13 = t_8.forgotPasswordUrl;
} else {
cb(new Error("cannot import 'forgotPasswordUrl'")); return;
}
context.setVariable("forgotPasswordUrl", t_13);
output += "\n\n\n<h2 id=\"a-modal-header\" class=\"c-modal-login__h2\">\n    ";
output += runtime.suppressValue((lineno = 6, colno = 6, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_sign-in",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n</h2>\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"login")),"messages")),"generalErrors")) {
output += "\n\n    <div class=\"c-modal-login__error-block\">\n\n        ";
output += runtime.suppressValue((lineno = 13, colno = 29, runtime.callWrap(t_4, "displayGeneralErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"login")),"messages")),"generalErrors"),runtime.makeKeywordArgs({"class": "c-form-block"})])), env.opts.autoescape);
output += "\n\n    </div>\n\n";
;
}
else {
output += "\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"login")),"messages")),"password_updated")) {
output += "\n\n        <div class=\"o-column\">\n\n            <div class=\"c-form__field has-success\">\n\n                <div class=\"c-form-block\">\n\n                    <p class=\"c-form-block__p\">\n\n                        ";
output += runtime.suppressValue((lineno = 29, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-password-success",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n\n                    </p>\n                </div>\n\n            </div>\n        </div>\n\n    ";
;
}
output += "\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/login/header.j2"] , dependencies)